var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyDealers',_vm._g(_vm._b({attrs:{"is-widget":""}},'MyDealers',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }